import React from 'react';
import * as TabsPrimitive from '@radix-ui/react-tabs';

/**
 * Tabs Components
 *
 * Wrapper for Radix UI Tabs with consistent styling.
 * Supports keyboard navigation and accessibility.
 *
 * TASK-168: Settings Page UI Component
 */

export const Tabs = TabsPrimitive.Root;

export const TabsList = React.forwardRef<
  React.ElementRef<typeof TabsPrimitive.List>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.List>
>(({ className = '', ...props }, ref) => (
  <TabsPrimitive.List
    ref={ref}
    className={`
      inline-flex items-center justify-center
      rounded-lg bg-gray-100 p-1
      ${className}
    `}
    {...props}
  />
));
TabsList.displayName = TabsPrimitive.List.displayName;

export const TabsTrigger = React.forwardRef<
  React.ElementRef<typeof TabsPrimitive.Trigger>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.Trigger>
>(({ className = '', ...props }, ref) => (
  <TabsPrimitive.Trigger
    ref={ref}
    className={`
      inline-flex items-center justify-center whitespace-nowrap
      rounded-md px-4 py-2
      text-sm font-medium
      ring-offset-white transition-all
      focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2
      disabled:pointer-events-none disabled:opacity-50
      data-[state=active]:bg-white data-[state=active]:text-gray-900 data-[state=active]:shadow-sm
      data-[state=inactive]:text-gray-600 data-[state=inactive]:hover:text-gray-900
      ${className}
    `}
    {...props}
  />
));
TabsTrigger.displayName = TabsPrimitive.Trigger.displayName;

export const TabsContent = React.forwardRef<
  React.ElementRef<typeof TabsPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.Content>
>(({ className = '', ...props }, ref) => (
  <TabsPrimitive.Content
    ref={ref}
    className={`
      mt-2 ring-offset-white
      focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2
      ${className}
    `}
    {...props}
  />
));
TabsContent.displayName = TabsPrimitive.Content.displayName;
